import globalEventEmitter from '../../modules/EventEmitter';
import { EVENTS, type TrialPayFlowContext } from '../../modules/EventEmitter/const';

export interface TrialPayFlowOpenState {
  isLoading: boolean;
  isOpening: boolean;
  isCheckoutVisible: boolean;
}

interface TrialPaymentContinuationOptions {
  continueGeneration: () => void;
  acknowledgeEntitlement: () => Promise<void>;
}

export async function runTrialPaymentContinuation({
  continueGeneration,
  acknowledgeEntitlement,
}: TrialPaymentContinuationOptions): Promise<boolean> {
  continueGeneration();

  try {
    await acknowledgeEntitlement();
    return true;
  } catch {
    return false;
  }
}

export function canOpenTrialPayFlow(input: TrialPayFlowOpenState) {
  return !input.isLoading && !input.isOpening && !input.isCheckoutVisible;
}

export function isPayBeforeLoginTrialPayment(
  context: TrialPayFlowContext | undefined,
) {
  return context?.loginAfterPayment === true;
}

export function openTrialPayModal(context?: TrialPayFlowContext) {
  globalEventEmitter.emit(EVENTS.OPEN_TRIAL_PAY_MODAL, context);
}

export function createTraceId() {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function getDuration(startTime: number | null) {
  if (startTime === null) {
    return null;
  }

  return Math.max(0, Math.round(performance.now() - startTime));
}
